module.exports = __webpack_public_path__ + "static/media/ruth.4d05cf4d.png";